import React from "react";

import svg from "../../assets/images/icons/steps/Run Tree Rule f.svg";

export const RunTreeRuleIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Run Tree Rule"}
    />
);
